import React, { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'

import HelpIcon from 'assets/images/help-terms.svg'
import DownloadIcon from 'assets/images/download-icon.svg'
import { getTerms, getTermsPdf } from 'api/term-conditions'
import Skeleton from 'react-loading-skeleton'
import handleNotification from 'utils/toast/handleNotification'
import { ZENDESK_URL } from 'config'

export default function TermsConditionsContent({
  onTermsLoaded,
  isModal = false
}) {
  const [bodyContent, setBodyContent] = useState(null)

  const { errorToast } = handleNotification()

  useEffect(() => {
    getTerms('WALLET')
      .then((terms) => {
        setBodyContent(terms?.body.replace(/\\"/g, '"'))
        onTermsLoaded?.(terms?.identifier)
      })
      .catch((error) => Sentry.captureException(error))
  }, [])

  function downloadPdf() {
    getTermsPdf()
      .then((result) => {
        if (!result.success) {
          errorToast(result?.error?.error.message)
        }
        const file = new Blob([result.data], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {
        console.log(error)
        errorToast(error?.error.message)
      })
  }
  return (
    <>
      {/* Terms and conditions text */}
      {bodyContent ? (
        // eslint-disable-next-line react/no-danger
        <div
          className={`font-light text-xs break-words leading-140 px-1 text-color-black mt-4 ${
            isModal && 'max-h-60 overflow-y-auto'
          }`}
          dangerouslySetInnerHTML={{ __html: bodyContent }}
        />
      ) : (
        <Skeleton height={20} count={10} />
      )}

      {/* Help and download buttons */}
      <div className={`flex items-center justify-between mt-5 `}>
        <a
          className='flex justify-start items-center py-[10px] hover:underline hover:underline-offset-1'
          href={ZENDESK_URL}
          target='_blank'
          rel='noreferrer'
        >
          <img src={HelpIcon} className='pr-[4px]' alt='ícono de ayuda' />
          <p className='text-[14px] text-purple-900 font-bold'>Ayuda</p>
        </a>

        <button
          type='button'
          onClick={() => {
            downloadPdf()
          }}
          className='flex justify-start items-center py-[10px] hover:underline hover:underline-offset-1'
        >
          <img
            src={DownloadIcon}
            className='pr-[4px]'
            alt='Ícono de descargar'
          />
          <p className='text-[14px] text-purple-900 font-bold'>Descargar</p>
        </button>
      </div>
    </>
  )
}
